import React, { useState } from 'react';
import {
    Route as ReactRouterRoute,
    Routes as ReactRouterRoutes,
} from 'react-router-dom';
import { Route } from '../../../../types';
import { DPage } from '../../../dum';
import { SBulkUpsertOrderProductionDialog, SUpsertOrderProductionDialog } from '../../../smart';
import { OrderProductionsPage } from './order-productions/order-productions-page';
import { OrderProductionPage } from './order-production/order-production-page';
import { DFab } from '../../../dum/simple/button/d-fab';
import { Fab, Tooltip } from '@mui/material';
import { FormatListBulleted as ListIcon } from '@mui/icons-material';

const productsPages: Route[] = [
    {
        name: 'OrderProductionsListPage',
        path: '/',
        component: <OrderProductionsPage />,
        title: 'Productos',
        navbar: false,
    },
    {
        name: 'OrderProductionPage',
        path: '/:orderProductionId',
        component: <OrderProductionPage />,
        title: 'Ordenes de produccion',
        navbar: false,
    },
];

export function OrderProductionsHomePage() {
    const [upsertOpen, setUpsertOpen] = useState(false);
    const [bulkOpen, setBulkOpen] = useState(false);

    return (
        <DPage>
            <DFab
                onClick={() => {
                    setUpsertOpen(true);
                }}
            />
            <Tooltip title={'Alta masiva'} placement={'left'}>
                <Fab
                    color={'secondary'}
                    sx={{ position: 'absolute', bottom: 32, right: 104 }}
                    onClick={() => setBulkOpen(true)}
                >
                    <ListIcon />
                </Fab>
            </Tooltip>
            <ReactRouterRoutes>
                {productsPages.map((page, index) => {
                    return (
                        <ReactRouterRoute
                            path={page.path}
                            element={page.component}
                            key={index}
                        />
                    );
                })}
            </ReactRouterRoutes>
            <SUpsertOrderProductionDialog
                open={upsertOpen}
                setOpen={setUpsertOpen}
            />
            <SBulkUpsertOrderProductionDialog
                open={bulkOpen}
                setOpen={setBulkOpen}
            />
        </DPage>
    );
}
